import { defineStore } from "pinia";
import type { City } from "~/stores/cities/types";

export const useCitiesStore = defineStore("cities", () => {
  const cities: Ref<City[]|null> = ref<City[]|null>(null);
  const activeCity: Ref<City|null> = ref<City|null>(null);

  const cityCookie = useCookie('active-city', {
    maxAge: 60 * 60 * 24 * 30,
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production'
  });

  const setActiveCity = (city: City) => {
    activeCity.value = city;
    cityCookie.value = city.id.toString();
  };

  async function fetchCities () {
    const response: any = await $fetch(useRuntimeConfig().public.api_host + 'api/cities');
    activeCity.value = response[0];
    return cities.value = response;
  }

  async function initActiveCity () {
    // Смотрим, есть ли город в куках, если да,
    // то устанавливаем его в качестве текущего.
    const cityId: number = Number(cityCookie.value) || 0;

    if (cityId > 0 && !!cities.value) {
      const city: City|undefined = cities.value.find(contact => contact.id === cityId);

      if (city) {
        activeCity.value = city;
        return;
      }
    }

    // Если текущий город не инициализирован, то проверяем,
    // что у нас подтянуты данные по городам.
    // Если из нет, подтягиваем.
    if (cities.value === null) {
      await fetchCities();
    }

    if (cities.value === null) {
      throw new Error('В БД отсутствуют населенные пункты!');
    }

    // Если в куках нет города, то устанавливаем в качестве
    // активного города первый город из списка городов.
    activeCity.value = cities.value[0];
    cityCookie.value = activeCity.value.id.toString();
  }

  return { cities, activeCity, setActiveCity, fetchCities, initActiveCity };
});
